import { PageSectionTitle as SectionTitle } from '@applyonline/shared'
import { Trans, useTranslation } from 'react-i18next'

const RefuseBanMessage = () => {
  const { t } = useTranslation()

  return (
    <main className="general-message" style={{ textAlign: 'center' }}>
      <SectionTitle title={t('common.financeApplication')} />
      <p style={{ textAlign: 'center' }}>
        <Trans i18nKey="ban.message" />
      </p>
    </main>
  )
}

export default RefuseBanMessage